import React from "react";
import $ from "jquery";

import Table from "./Table";
import Detail from "./Detail";
import PlaatsInBudget from "./modals/plaatsInBudget";
import PlaatsInWerkplan from "./modals/plaatsInWerkplan";
import WijzigStatus from "./modals/wijzigStatus";
import PlaatsInUitvoering from "./modals/plaatsUitvoering";
import PlaatsInDetailPlanning from "./modals/plaatsDetailplanning";
import NatureProtection from "../../../common/natureProtection/natureProtection";
import BulkUpdate from "./modals/bulkUpdate/bulkUpdate";

class WorkResources extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  /** React Life Cycle Functions */
  async componentDidMount() {
    var that = this;

    var popup_id;
    /** ekranın herhangi biryerine tıklanınca popup kaldırma için kullanılan fonksiyon */
    $(document)
      .unbind("mouseup")
      .mouseup(function (e) {
        var popup = $("#myPopup");
        if (
          !$("div.popup").is(e.target) &&
          !popup.is(e.target) &&
          popup.has(e.target).length === 0
        ) {
          $("#myPopup").html("");
          var popup = document.getElementById("myPopup");
          $("#myPopup").removeClass("show");
        }

        let id = e.target.id;

        if (id !== "") {
          popup = $("#" + e.target.id);
          popup_id = id;
        } else popup = null;

        if (
          popup === null &&
          e.target.className != "checkmark-green" &&
          e.target.className != "filter-container" &&
          e.target.className != "checkmark-red"
        ) {
          $(
            "#short-table-popup-" +
              String(popup_id)
                .replace("-input-true", "")
                .replace("-input-false", "")
          ).removeClass("show");
        }
      });
  }

  render() {
    return (
      <div>
        <div className="border p-3 br5 full-width" id="border-mid">
          <Table {...this.props} />
          <Detail />
          <PlaatsInBudget />
          <PlaatsInWerkplan />
          <WijzigStatus />
          <PlaatsInUitvoering />
          <PlaatsInDetailPlanning />
          <NatureProtection />
          <BulkUpdate />
        </div>
      </div>
    );
  }
}

export default WorkResources;
